// extracted by mini-css-extract-plugin
module.exports = {"headline":"n2IQO","headlineWithPosition":"_1egtq"};